import { AbstractModel } from '../base';
import {
  IDocument,
  IDocumentData,
  IDocumentRevision,
  IDocumentRevisionData,
  IDocumentTag,
  IDocumentTagData
} from './document.types';

export class Document extends AbstractModel implements IDocument {
  id?: number;
  title: string;
  description: string;

  file?: File;
  created_at?: Date;
  latest_revision?: IDocumentRevision;
  tags?: IDocumentTag[] = [];

  constructor(data: IDocumentData) {
    super();

    const requiredFields: (keyof IDocumentData)[] = ['title'];
    this.validate(data, requiredFields);

    this.title = data.title!;

    this.description = data.description ?? '';

    if (data.created_at) {
      this.created_at =
        typeof data.created_at === 'string'
          ? new Date(data.created_at)
          : data.created_at;
    }

    if (data.id) {
      this.id = data.id;
    }

    if (data.file) {
      this.file = data.file;
    }

    if (data.latest_revision) {
      this.latest_revision = new DocumentRevision(data.latest_revision);
    }

    if (data.tags) {
      this.tags = data.tags.map(tag => new DocumentTag(tag));
    }
  }

  toString(): string {
    return this.title;
  }
}

export class DocumentTag extends AbstractModel implements IDocumentTag {
  id?: number;
  label: string;

  constructor(data: IDocumentTagData) {
    super();

    const requiredFields: (keyof IDocumentTagData)[] = ['label'];
    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.label = data.label!;
  }

  toString(): string {
    return this.label;
  }
}

export class DocumentRevision extends AbstractModel
  implements IDocumentRevision {
  id: number;
  owner: string;
  revision: number;
  uploaded_at: Date;
  file: string;

  constructor(data: IDocumentRevisionData) {
    super();

    const requiredFields: (keyof IDocumentRevisionData)[] = [
      'id',
      'owner',
      'revision',
      'uploaded_at',
      'file'
    ];
    this.validate(data, requiredFields);

    this.id = data.id!;
    this.owner = data.owner!;
    this.revision = data.revision!;

    this.uploaded_at = new Date(data.uploaded_at!);

    this.file = data.file!;
  }
}
